import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Popup from "reactjs-popup";
import { richTextContentFromHtml } from '../../shared/utils/richTextHtml';
import {EditorState} from 'draft-js';
import UnpastModal from '../../EventPage/components/actions/UnpastModal';
import {
  Button, CalendarCheck01, Checkbox, CalendarDate, CalendarMinus01, ChevronDown, ClipboardCheck, Clock, Code01, Copy01, LayersThree01, File06, Printer, QrCode01, RefreshCw01, Send01, Share07, Trash01
} from '@opendate-app/setlist';

const popupContentStyle = {
  "background": "var(--sl-bg-primary)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "250px",
  "padding": "4px 0",
  "zIndex": 9999
}

const deleteModalContentStyle = {
  "background": "var(--sl-bg-primary)",
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "500px",
  "padding": "15px"
}

const ConfirmActionMenu = ({
  confirm,
  csrfToken,
  team,
  currentUser,
  deleteConfirm,
  cancelConfirm,
  showAdvanceSendChanged,
  confirmInvitationChanged,
  uncancelConfirm,
  postponeConfirm,
  unpostponeConfirm,
  mayCancelConfirm,
  mayUncancelConfirm,
  mayUnpastConfirm,
  unpastTimeZone,
  unpastBlockers,
  postEventSideEffects,
  setConfirmToDup,
  setMakeRecurringOpen,
  selectedPromoter,
  selectedBuyer,
  showWidgetCodeChanged,
}) => {
  const [unpastOpen, setUnpastOpen] = useState(false);
  const [pauseSales, setPauseSales] = useState(true);
  const [makePrivate, setMakePrivate] = useState(true);
  const [resumeSales, setResumeSales] = useState(true);
  const [makePublic, setMakePublic] = useState(true);

  return (
    <>
    <Popup arrow={false}
          offsetY={5}
          position="bottom right"
          contentStyle={popupContentStyle}
          onOpen={
            (e) => {
              e.stopPropagation();
              e.preventDefault();
            }
          }
          trigger={open => (
            <span className="classic-actions-trigger">
              <Button variant="primary" trailingIcon={ChevronDown}>Actions</Button>
            </span>
          )} >
      {close => (
        <div className='row text-left'>
          <div className="col-12">
            <ul className="list-group classic-actions-menu">
              {currentUser.can_create_invitation ? (
                <li className="list-group-item">
                  <a href={"#"}
                    onClick={
                      (e) => {
                        e.preventDefault();
                        confirmInvitationChanged({team: team});
                        close();
                      }
                    }
                    className="text-muted">
                    <Share07 width={16} height={16} aria-hidden="true" />
                    Share this page
                  </a>
                </li>
              ) : null}
              {currentUser.can_create_show_advance_send ? (
                <li className="list-group-item">
                  <a href="#"
                    onClick={
                      (e) => {
                        e.preventDefault();
                        showAdvanceSendChanged({calendar_event_id: confirm.id});
                        close();
                      }
                    }
                    className="text-muted">
                    <Send01 width={16} height={16} aria-hidden="true" />
                    Send show advance
                  </a>
                </li>
              ) : null}
              <li className="list-group-item">
                <a href="#"
                  onClick={
                    (e) => {
                      e.preventDefault();
                      showAdvanceSendChanged({calendar_event_id: confirm.id});
                      close();
                    }
                  }
                  className="text-muted">
                  <Printer width={16} height={16} aria-hidden="true" />
                  Print show advance
                </a>
              </li>
              <li className="list-group-item">
                <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/confirmation_memo"}
                  className="text-muted">
                  <File06 width={16} height={16} aria-hidden="true" />
                  Confirmation memo
                </a>
              </li>
              <li className="list-group-item">
                <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/event_qr_code"}
                  className="text-muted">
                  <QrCode01 width={16} height={16} aria-hidden="true" />
                  Event QR code
                </a>
              </li>
              {confirm.type === "Confirm" && confirm.published_at ? (
                <li className="list-group-item">
                  <a href={"/teams/" + team.id + "/confirms/" + confirm.id + "/ticket_audit"}
                    className="text-muted">
                    <ClipboardCheck width={16} height={16} aria-hidden="true" />
                    View ticket audit
                  </a>
                </li>
              ) : null}
              {confirm.type === "Confirm" && confirm.published_at ? (
                <li className="list-group-item">
                  <a href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      showWidgetCodeChanged(true);
                      close();
                    }}
                    className="text-muted">
                    <Code01 width={16} height={16} aria-hidden="true" />
                    Embed widget
                  </a>
                </li>
              ) : null}
              {confirm.type === "Confirm" && currentUser.can_create_calendar_event ? (
                <li className="list-group-item">
                  <a href={"/teams/" + team.id + "/event_series"}
                    className="text-muted">
                    <LayersThree01 width={16} height={16} aria-hidden="true" />
                    Add event to series
                  </a>
                </li>
              ) : null}
              {confirm.type === "Confirm" && currentUser.can_create_calendar_event ? (
                <li className="list-group-item">
                  <a href={"#"}
                    onClick={e => {
                      e.preventDefault();

                      const now = new Date();
                      const startTime = new Date(confirm.start_time);
                      const endTime = new Date(confirm.end_time);
                      const doorTime = new Date(confirm.door_time);

                      const eventInFuture = startTime > now;

                      setConfirmToDup({
                        ...confirm,
                        start_time: eventInFuture ? startTime : undefined,
                        end_time: eventInFuture ? endTime : undefined,
                        door_time: eventInFuture ? doorTime : undefined,
                        note_state: confirm.note ? EditorState.createWithContent(richTextContentFromHtml(confirm.note.body)) : undefined,
                        promoter: selectedPromoter,
                        buyer: selectedBuyer,
                        copy_offer_ids: (confirm.copyable_offers || []).map((offer) => offer.id),
                      });

                      close();
                    }}
                    className="text-muted">
                    <Copy01 width={16} height={16} aria-hidden="true" />
                    Duplicate event
                  </a>
                </li>
              ) : null}
              {confirm.type === "Confirm" && currentUser.can_create_calendar_event ? (
                <li className="list-group-item">
                  <a href={"#"}
                    onClick={e => {
                      e.preventDefault();
                      setMakeRecurringOpen(true);
                      close();
                    }}
                    className="text-muted">
                    <RefreshCw01 width={16} height={16} aria-hidden="true" />
                    Make this a recurring event
                  </a>
                </li>
              ) : null}
              {confirm.type === "Confirm" && confirm.calendar_classification !== "postponed" && confirm.calendar_classification !== "canceled" && currentUser.can_cancel_calendar_event ? (
                <li className="list-group-item is-status">
                  <Popup
                      trigger={
                        <a href="#" className="text-muted">
                          <Clock width={16} height={16} aria-hidden="true" />
                          Postpone event
                        </a>
                      }
                      modal
                      onOpen={
                        (e) => {
                          e.preventDefault();
                          setPauseSales(true);
                          setMakePrivate(true);
                        }
                      }
                      contentStyle={deleteModalContentStyle}
                      closeOnDocumentClick
                    >
                    {closePostponePopup => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <h5 style={{"marginBottom": "16px"}}>
                                  <strong>Postpone this event?</strong>
                                </h5>
                              </div>
                              <div className="col-xs-auto">
                                <a href="#"
                                  className="text-dark"
                                  style={{"paddingRight": "15px"}}
                                  onClick={(e) => {e.preventDefault(); close();}} >
                                  <i className="fa fa-times"></i>
                                </a>
                              </div>
                            </div>
                            <p>The event keeps its current date on your calendar and stops counting as a past event, so you can move it once a new date is set. Ticket sales are not paid out while it is postponed.</p>
                            <div className="mb-3">
                              <Checkbox
                                id="postpone-pause-sales"
                                label="Pause ticket sales"
                                checked={pauseSales}
                                onChange={(e) => setPauseSales(e.target.checked)}
                              />
                              <Checkbox
                                id="postpone-make-private"
                                label="Make event private"
                                checked={makePrivate}
                                onChange={(e) => setMakePrivate(e.target.checked)}
                              />
                            </div>
                            <div className="text-right">
                              <a href="#"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                  }
                                }>
                                No thanks
                              </a>
                              <a href="#"
                                className="btn btn-danger ml-3"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    closePostponePopup();
                                    postponeConfirm(csrfToken, team, confirm, {pause_sales: pauseSales, make_private: makePrivate});
                                  }
                                }>
                                Yes, postpone
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                </li>
              ) : null}
              {confirm.calendar_classification === "postponed" && currentUser.can_cancel_calendar_event ? (
                <li className="list-group-item is-status">
                  <Popup
                      trigger={
                        <a href="#" className="text-muted">
                          <CalendarCheck01 width={16} height={16} aria-hidden="true" />
                          Un-postpone event
                        </a>
                      }
                      modal
                      onOpen={
                        (e) => {
                          e.preventDefault();
                          setResumeSales(true);
                          setMakePublic(true);
                        }
                      }
                      contentStyle={deleteModalContentStyle}
                      closeOnDocumentClick
                    >
                    {closeUnpostponePopup => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <h5 style={{"marginBottom": "16px"}}>
                                  <strong>Un-postpone this event?</strong>
                                </h5>
                              </div>
                              <div className="col-xs-auto">
                                <a href="#"
                                  className="text-dark"
                                  style={{"paddingRight": "15px"}}
                                  onClick={(e) => {e.preventDefault(); close();}} >
                                  <i className="fa fa-times"></i>
                                </a>
                              </div>
                            </div>
                            <p>The event goes back to the status its dates call for. Update the date first if it has already gone by.</p>
                            <div className="mb-3">
                              <Checkbox
                                id="unpostpone-resume-sales"
                                label="Resume ticket sales"
                                checked={resumeSales}
                                onChange={(e) => setResumeSales(e.target.checked)}
                              />
                              <Checkbox
                                id="unpostpone-make-public"
                                label="Make event public"
                                checked={makePublic}
                                onChange={(e) => setMakePublic(e.target.checked)}
                              />
                            </div>
                            <div className="text-right">
                              <a href="#"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                  }
                                }>
                                No thanks
                              </a>
                              <a href="#"
                                className="btn btn-primary ml-3"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    closeUnpostponePopup();
                                    unpostponeConfirm(csrfToken, team, confirm, {resume_sales: resumeSales, make_public: makePublic});
                                  }
                                }>
                                Yes, un-postpone
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                </li>
              ) : null}
              {currentUser.can_unpast_calendar_event && mayUnpastConfirm ? (
                <li className="list-group-item is-status">
                  <a
                    href="#"
                    className="text-muted"
                    onClick={(e) => { e.preventDefault(); close(); setUnpastOpen(true); }}
                  >
                    <CalendarCheck01 width={16} height={16} aria-hidden="true" />
                    Move out of Past
                  </a>
                </li>
              ) : null}
              {confirm.calendar_classification !== "canceled" && currentUser.can_cancel_calendar_event && mayCancelConfirm ? (
                <li className="list-group-item is-status">
                  <Popup
                      trigger={
                        <a href="#" className="text-muted">
                          <CalendarMinus01 width={16} height={16} aria-hidden="true" />
                          Cancel event
                        </a>
                      }
                      modal
                      onOpen={
                        (e) => {
                          e.preventDefault();
                        }
                      }
                      contentStyle={deleteModalContentStyle}
                      closeOnDocumentClick
                    >
                    {closeDeletePopup => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <h5 style={{"marginBottom": "16px"}}>
                                  <strong>Cancel this event?</strong>
                                </h5>
                              </div>
                              <div className="col-xs-auto">
                                <a href="#"
                                  className="text-dark"
                                  style={{"paddingRight": "15px"}}
                                  onClick={(e) => {e.preventDefault(); close();}} >
                                  <i className="fa fa-times"></i>
                                </a>
                              </div>
                            </div>
                            <p>Are you sure you want to cancel this event in Opendate?</p>
                            <div className="text-right">
                              <a href="#"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                  }
                                }>
                                No thanks
                              </a>
                              <a href="#"
                                className="btn btn-danger ml-3"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    closeDeletePopup();
                                    cancelConfirm(csrfToken, team, confirm);
                                  }
                                }>
                                Yes, cancel
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                </li>
              ) : null}
              {confirm.calendar_classification === "canceled" && currentUser.can_cancel_calendar_event && mayUncancelConfirm ? (
                <li className="list-group-item is-status">
                  <Popup
                      trigger={
                        <a href="#" className="text-muted">
                          <CalendarDate width={16} height={16} aria-hidden="true" />
                          Uncancel event
                        </a>
                      }
                      modal
                      onOpen={
                        (e) => {
                          e.preventDefault();
                        }
                      }
                      contentStyle={deleteModalContentStyle}
                      closeOnDocumentClick
                    >
                    {closeDeletePopup => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <h5 style={{"marginBottom": "16px"}}>
                                  <strong>Uncancel this event?</strong>
                                </h5>
                              </div>
                              <div className="col-xs-auto">
                                <a href="#"
                                  className="text-dark"
                                  style={{"paddingRight": "15px"}}
                                  onClick={(e) => {e.preventDefault(); close();}} >
                                  <i className="fa fa-times"></i>
                                </a>
                              </div>
                            </div>
                            <p>Are you sure you want to uncancel this event?</p>
                            <div className="text-right">
                              <a href="#"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                  }
                                }>
                                No thanks
                              </a>
                              <a href="#"
                                className="btn btn-danger ml-3"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    closeDeletePopup();
                                    uncancelConfirm(csrfToken, team, confirm);
                                  }
                                }>
                                Yes, uncancel
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                </li>
              ) : null}
              {currentUser.can_destroy_calendar_event ? (
                <li className="list-group-item is-danger">
                  <Popup
                      trigger={
                        <a href="#" className="text-danger">
                          <Trash01 width={16} height={16} aria-hidden="true" />
                          Remove
                        </a>
                      }
                      modal
                      onOpen={
                        (e) => {
                          e.preventDefault();
                        }
                      }
                      contentStyle={deleteModalContentStyle}
                      closeOnDocumentClick
                    >
                    {closeDeletePopup => (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <h5 style={{"marginBottom": "16px"}}>
                                  <strong>Delete confirm?</strong>
                                </h5>
                              </div>
                              <div className="col-xs-auto">
                                <a href="#"
                                  className="text-dark"
                                  style={{"paddingRight": "15px"}}
                                  onClick={(e) => {e.preventDefault(); close();}} >
                                  <i className="fa fa-times"></i>
                                </a>
                              </div>
                            </div>
                            <p>{"Remove confirm from your Opendate account?"}</p>
                            <div className="text-right">
                              <a href="#"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                  }
                                }>
                                Cancel
                              </a>
                              <a href="#"
                                className="btn btn-danger ml-3"
                                onClick={
                                  (e) => {
                                    e.preventDefault();
                                    close();
                                    closeDeletePopup();
                                    deleteConfirm(csrfToken, team, confirm);
                                  }
                                }>
                                Remove
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Popup>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      )}
    </Popup>
    {mayUnpastConfirm && (
      <UnpastModal
        open={unpastOpen}
        onClose={() => setUnpastOpen(false)}
        teamId={team.id}
        confirm={{ id: confirm.id, timeZone: unpastTimeZone }}
        blockers={unpastBlockers}
        sideEffects={postEventSideEffects}
        csrfToken={csrfToken}
        onRestored={() => window.location.reload()}
      />
    )}
    </>
  );
};

ConfirmActionMenu.propTypes = {
  confirm: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  deleteConfirm: PropTypes.func.isRequired,
  cancelConfirm: PropTypes.func.isRequired,
  showAdvanceSendChanged: PropTypes.func.isRequired,
  confirmInvitationChanged: PropTypes.func.isRequired,
  uncancelConfirm: PropTypes.func.isRequired,
  postponeConfirm: PropTypes.func.isRequired,
  unpostponeConfirm: PropTypes.func.isRequired,
  mayUnpastConfirm: PropTypes.bool,
  unpastTimeZone: PropTypes.string,
  unpastBlockers: PropTypes.arrayOf(PropTypes.string),
  postEventSideEffects: PropTypes.object,
  mayCancelConfirm: PropTypes.bool,
  mayUncancelConfirm: PropTypes.bool,
  setConfirmToDup: PropTypes.func.isRequired,
  setMakeRecurringOpen: PropTypes.func.isRequired,
  selectedPromoter: PropTypes.object,
  selectedBuyer: PropTypes.object,
  showWidgetCodeChanged: PropTypes.func,
};

export default ConfirmActionMenu;
